import {type ProjectTemplate} from '../initProject'

const quickStartTemplate: ProjectTemplate = {}

export default quickStartTemplate
